var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"k-primary k-button k-grid-edit-command",attrs:{"type":"button"},on:{"click":_vm.editHandler}},[_c('span',{staticClass:"icon icon-edit"})])
}
var staticRenderFns = []

export { render, staticRenderFns }